import React from "react";
import { Match } from "../../types";
import cx from "classnames";
import { getMatchStatus, getScore } from "./matchFunctions";
import moment from "moment";

function scoreDisplay(myScore, otherScore) {
	return myScore.map((points, index) => {
		const otherPoints = otherScore[index];
		const className = cx({ higher: points > otherPoints });

		return (
			<div className={className} key={index}>
				{points}
			</div>
		);
	});
}

const MatchDetail = ({ match }: { match: Match }) => {
	const me = match.createdBy === match.playerA.userId ? match.playerA : match.playerB;
	const otherPlayer = match.createdBy !== match.playerA.userId ? match.playerA : match.playerB;

	const className = cx({ practice: match.practice, confirmed: match.confirmed, disputed: match.disputed });

	const myScore = getScore(me.userId, match.score).score;
	const otherScore = getScore(otherPlayer ? otherPlayer.userId : null, match.score).score;

	return (
		<div className={className}>
			Match
			{getMatchStatus(match.winnerId, me.userId)}
			{moment.unix(match.date).format("LL")}
			{scoreDisplay(myScore, otherScore)}
			<br />
			{otherPlayer ? (
				<div>
					{otherPlayer.firstName} {otherPlayer.lastName} <br />
					{scoreDisplay(otherScore, myScore)}
				</div>
			) : null}
		</div>
	);
};

export default MatchDetail;
